<script setup lang="ts">
  import {ref} from 'vue';
  import useCpBem from '~/composables/useCpBem';
  import CpText from '~/components/cp/CpText/CpText.vue';
  import CpIconStandard from '~/components/cp/CpIcon/CpIconStandard/CpIconStandard.vue';

  defineProps<{
        /** This component appears when filters are applied within a Category or section.
         * Unlike other pills, these are actionable, as the user can remove the applied filters. **/
        filterTex: string,
      }>();
  const {b, e} = useCpBem('cp-filter-pill');
  const pressed = ref(false);
</script>

<template>
    <button
        :class="b"
        @mousedown="pressed = true"
        @mouseup="pressed = false"
    >
        <CpText
            :class="e`text`"
            variant="caption-bold"
            :type="pressed ? 'primary-dark' : 'primary'"
        >
            {{ filterTex }}
        </CpText>
        <CpIconStandard
            icon="close"
            :type="pressed ? 'primary-dark' : 'primary'"
            kind="small"
        />
    </button>
</template>

<style scoped lang="scss">
    .cp-filter-pill {
      min-height: 20px;
      width: fit-content;
      display: flex;
      gap: 4px;
      justify-content: center;
      align-items: center;
      padding: 0 8px;
      border-radius: 16px;
      background: var(--color-white);
      border: 1px solid var(--color-primary);
      &:active {
        border: 1px solid var(--color-primary-dark);
        background: var(--color-primary-extra-light);
      }
    }
</style>
